import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { QueryResult } from "@/api/utils/types"
import { ICoreMeterpoint } from "@/models/admin/coreMeterpoint/coreMeterpoint.types"
import {
  CoreMeterpointParser,
  ICoreMeterpointRaw,
} from "@/models/admin/coreMeterpoint/coreMeterpoint.parser"

class CoreMeterpointServiceClass {
  getForAccount(coreAccountId: number): QueryResult<ICoreMeterpoint[]> {
    return useQuery({
      ...BackofficeRestQueries.meterpoints.forCoreAccount(coreAccountId),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData: ICoreMeterpointRaw[]) =>
        (rawData ?? []).map((meterpoint) =>
          CoreMeterpointParser.toDomain(meterpoint),
        ),
    })
  }
}

export const CoreMeterpointService = new CoreMeterpointServiceClass()
